import React from "react";
import Link from "next/link";
import { ArticleShort } from "lib/types/article";
import ArticleHeadline from "components/article/ArticleHeadline";

interface SmallArticleStackProps {
  articles: ArticleShort[];
}

const SmallArticleStack = ({ articles }: SmallArticleStackProps) => {
  return (
    <div className="flex w-full flex-col gap-2">
      {articles.map((article) => {
        const borderColor = article.isProContent
          ? "border-pro"
          : "border-sifted";
        return (
          <Link
            href={article.url}
            key={article.id || article.url}
            className="group block"
          >
            <div
              className={`flex flex-col gap-1 border-l-[1px] ${borderColor} pl-[8px] transition-colors`}
            >
              <ArticleHeadline
                title={article.title}
                isProContent={article.isProContent}
                className="flex-1"
              />
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default SmallArticleStack;
